// extracted by mini-css-extract-plugin
module.exports = {"item":"_cd25cc7","link":"_cc0eae32","title":"_358ae5d2","image":"_c7e868b5","cta":"_2402f624","shimmerLoadingBackground":"_25b24dff"};